module.exports = __webpack_public_path__ + "assets/navSvg3.77f604e4.svg";